<script setup>
</script>

<template>

  <div class="bg-primary text-basecolor py-8 md:py-24 px-6">
    <div class="mx-auto max-w-7xl p-10">
      <div class="mx-auto max-w-2xl px-4 lg:max-w-none">
        <div class="max-w-3xl">
          <h2 class="text-3xl font-semibold tracking-tight">
            {{ $t('landingPage.whySection.title') }}
          </h2>
        </div>

        <div class="mt-8 grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-10">
          <!-- block1 -->
          <div class="md:col-span-2">
            <h3 class="text-xl font-semibold tracking-tight">
              {{ $t('landingPage.whySection.block1.title') }}
            </h3>
            <p class="mt-4 text-md">
              {{ $t('landingPage.whySection.block1.text') }}
            </p>
          </div>
          <!-- block2 -->
          <div class="pt-4">
            <h3 class="text-xl font-semibold tracking-tight">
              {{ $t('landingPage.whySection.block2.title') }}
            </h3>
            <div class="mt-4">
              <ul class="mt-4 list-disc list-outside text-md pl-5">
                <li>{{ $t('landingPage.whySection.block2.bullet1') }}</li>
                <li>{{ $t('landingPage.whySection.block2.bullet2') }}</li>
                <li>{{ $t('landingPage.whySection.block2.bullet3') }}</li>
              </ul>
            </div>
          </div>
          <div class="flex flex-col items-center justify-center text-center">
            <img
                src="../../assets/nis2.png"
                alt=""
                class="rounded-xl shadow-lg max-w-full max-h-56"
            />
            <a
                href="https://www.enisa.europa.eu/topics/awareness-and-cyber-hygiene/raising-awareness-campaigns/network-and-information-systems-directive-2-nis2"
                class="mt-4 text-md font-medium text-accent hover:underline"
                target="_blank"
            >
              {{ $t('landingPage.whySection.imageLink') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
